import { ActionState } from "../state/core.state"
import { autoLogin, appLogout, localAuthRequired } from "../thunks/auth.thunks"
import { getAppConfig } from "../thunks/config.thunks"
import { getPendingEulas } from "../thunks/eula.thunks"
import { setApplicationMessages } from "../thunks/messages.thunks"
import { fetchProvisioningMessages } from "../thunks/provisioning.thunks"
import { fetchUserInfo } from "../thunks/user.thunks"

/**
 * @legacy Bridge middleware — supports plain-object dispatch from consumer apps.
 *
 * Maps legacy effect-only action types to their createAsyncThunk replacements.
 * When a consumer dispatches a plain-object action like:
 *   coreStore.dispatch({ type: AUTO_LOGIN })
 * this middleware intercepts it and dispatches the corresponding thunk.
 * Thunk-dispatched actions (which have `action.meta`) pass through unchanged.
 *
 * Remove once all apps are migrated to dispatch thunks directly
 * (e.g., coreStore.dispatch(autoLogin())) instead of plain-object actions.
 */
const effectThunkMap: Record<string, any> = {
  [ActionState.AUTO_LOGIN]: autoLogin,
  [ActionState.FETCH_USER_INFO]: fetchUserInfo,
  [ActionState.GET_APP_CONFIG]: getAppConfig,
  [ActionState.APP_LOGOUT]: appLogout,
  [ActionState.GET_PENDING_EULAS]: getPendingEulas,
  [ActionState.SET_APPLICATION_MESSAGES]: setApplicationMessages,
  [ActionState.FETCH_PROVISIONING_MESSAGES]: fetchProvisioningMessages,
  [ActionState.LOCAL_AUTH_REQUIRED]: localAuthRequired
}

export const legacyBridgeMiddleware = (store) => (next) => (action) => {
  const thunkCreator = effectThunkMap[action.type]
  // Only intercept plain-object dispatches (no action.meta from createAsyncThunk)
  if (thunkCreator && !action.meta) {
    return store.dispatch(thunkCreator(action))
  }
  return next(action)
}
